import request from '@/utils/request'

export function reqStaffInfo(data) {
  return request({
    url: '/api/staff/getStaffInfo',
    method: 'post',
    data: {
      data
    }
  })
}

export function addStaff(data) {
  return request({
    url: '/api/staff/addStaff',
    method: 'post',
    data: {
      data
    }
  })
}

export function getStaffList() {
  return request({
    url: '/api/staff/getStaffList',
    method: 'get'
  })
}

export function deleteStaff(data) {
  return request({
    url: "/api/staff/delete",
    method: 'post',
    data: {
      data
    }
  })
}

export function editStaff(data) {
  return request({
    url: '/api/staff/edit',
    method: 'post',
    data: {
      data
    }
  })
}